import { Inject } from '@odinjs/odin';
import { TextAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ConfigurationService, HistoryService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';

import { FragmentNames, InactivityAliases } from '../codegen';

@Controller({ fragment: FragmentNames.INACTIVITY })
export default class InactivityController {

  @Inject(InactivityAliases.INACTIVITY_MESSAGE_TEXT)
  inactivityMessageText!: TextAPI;

  configuration = ConfigurationService.getAuthenticationConfiguration();

  @OnMount({ target: InactivityAliases.MAIN_LAYOUT })
  onMainLayoutMount(): void {
    const limit = this.configuration ? this.configuration.inactivity.time / 1000 / 60 : 0;
    this.inactivityMessageText.setValue(MessageService.translate('inactivity.message', { limit } ));
  }

  @OnClick({ target: InactivityAliases.GO_TO_LOGIN_BUTTON })
  onGoToLoginButtonClick(): void {
    HistoryService.push(this.configuration ? this.configuration.routes.login : '');
  }
}
